import * as React from "react"
import { useMemo } from "react"

interface FormattedCurrencyProps {
    children: number
    currency?: string
    round?: boolean
}

export const formatCurrency = (value: number, currency?: string, round?: boolean) => {
    const formatter = new Intl.NumberFormat("nb-NO", {
        style: 'currency',
        currency: currency ?? 'NOK',
        maximumFractionDigits: round ? 0 : 2
    })
    return formatter.format(value)
}

export const FormattedCurrency: React.FC<FormattedCurrencyProps> = ({currency, round, children}) => {
    const formatted = useMemo(() => {
        return formatCurrency(children, currency, round)
    }, [children])

    return (
        <React.Fragment>{formatted}</React.Fragment>
    )
}